import styled from "styled-components"

export default {
    "Wrapper": styled.main`
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 96px 28px;
        gap: 60px;
    `,

    "Title": styled.h1`
        ${({ theme }) => theme.font["heading-bold"]};
    `,

    "SignupForm": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    `,
    "ShowButton": styled.button`
        display: flex;
        align-items: center;
    `,

    "ProfileImgDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;

        & > h2 {
            ${({ theme }) => theme.font["large-semibold"]};

            span {
                color: ${({ theme }) => theme.color["error"]};
            }
        }

        & > button {
            width: fit-content;
            position: relative;
        }

        & > p {
            ${({ theme }) => theme.font["small-medium"]};
            color: ${({ theme }) => theme.color["grey3"]};
        }
    `,
    "ProfileImg": styled.img`
        width: 92px;
        height: 92px;
        object-fit: cover;
        object-position: center center;
        border-radius: 50%;
    `,
    "ProfileOption": styled.img`
        position: absolute;
        right: -6px;
        bottom: 5px;
        width: 32px;
    `,

    "SignupButtonDiv": styled.div`
        width: 100%;
    `,
}